import Checkbox from 'components/commons/checkbox'
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { capitalize } from 'utils/utils'
import { Card } from './Card'

export const HappinessIndex = ({
    data,
    styleBar,
    isLoading,
    filter,
    onSubmitFilter,
    years,
    checkedItem,
    onChangeChecked,
}) => {
    return (
        <Card
            isLoading={isLoading}
            title='Happiness Index Trend'
            filterTitle='Filter Happiness Index'
            initFilter={filter}
            initOptions={{ year: years }}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='gap-10 mt-4 h-56 relative'>
                <div className='flex items-center gap-6 pb-5'>
                    {Object.keys(checkedItem || {}).map((key, index) => {
                        if (key !== 'period') {
                            return (
                                <div key={index} className='flex items-center'>
                                    <Checkbox
                                        name={key}
                                        checked={!!checkedItem[key]}
                                        onChange={onChangeChecked}
                                        className='-mr-1.5 -ml-3'
                                    />
                                    <div className='w-4 h-1' style={{ backgroundColor: styleBar(key) }} />
                                    <div className='capitalize text-neutral-80 pl-1'>
                                        {key === 'pnc' ? 'P&C' : capitalize(key?.replaceAll('_', ' '))}
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
                <ResponsiveContainer width='100%' height='100%'>
                    <LineChart data={data}>
                        <XAxis dataKey='period' />
                        <YAxis hide />
                        <Tooltip formatter={(value) => `${value}%`} />
                        {Object.keys(data[0] || {})?.map((key, index) => {
                            if (key !== 'period')
                                return (
                                    <Line
                                        key={index}
                                        type='monotone'
                                        dataKey={key}
                                        name={key === 'pnc' ? 'P&C' : capitalize(key?.replaceAll('_', ' '))}
                                        stroke={styleBar(key)}
                                        strokeWidth={3}
                                        dot={false}
                                    />
                                )
                        })}
                    </LineChart>
                </ResponsiveContainer>

                {!data?.length && (
                    <div className='absolute inset-0 flex items-center justify-center font-semibold text-neutral-60'>
                        Data Not Available
                    </div>
                )}

                <div className='flex gap-1.5 items-center w-fit px-2 py-1 mx-auto bg-neutral-10 border border-neutral-20 rounded-lg'>
                    <div className='w-3 h-3 bg-green-50 rounded-full'></div>
                    <span className='text-primary-50 font-semibold'>
                        {filter?.start_year === filter?.end_year
                            ? filter?.start_year
                            : `${filter?.start_year} - ${filter?.end_year}`}
                    </span>
                </div>
            </div>
        </Card>
    )
}
